<div style="padding: 8dvh;">
    <h2 class="mb-3"  mat-dialog-title><b>THANK YOU FOR YOUR REQUEST</b></h2>
    <mat-dialog-content style="width: 80%;">
      <p style="color: black;">We have received your request. We will process this and get back to you by emall within a week.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close [mat-dialog-close]="true" (click)="redirigir()" class="btn btn-dark">GOT IT</button>
    </mat-dialog-actions>
    </div>